<script setup lang="ts">
import { useRoute } from 'vue-router';
import Footer from './components/item/Footer.vue';

const route = useRoute();
</script>

<template>
  <div class="min-h-screen background bg-white flex flex-col">
    <div v-if="route.path === '/'" class="flex-grow flex flex-col items-center justify-center">
      <!-- <img src="@/assets/xs_odihnx_logo.png" alt="XS Odihnx Logo" class="mb-4 w-2/4 sm:w-2/6 md:w-2/8 lg:w-2/10" />
      <img src="@/assets/odihnx.png" alt="Odihnx Logo" class="w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5" /> -->
    </div>
    <router-view />
    <Footer v-if="route.path === '/'" class="mt-auto" />
  </div>
</template>
